
import Vue from 'vue'
import baseMixin from 'uni-mixins/base'
import animation from 'uni-mixins/animation'
import Button from 'uni-view/components/button'
import Canvas from 'uni-view/components/canvas'
import CoverView from 'uni-platform/view/components/cover-view'
import Image from 'uni-view/components/image'
import Input from 'uni-view/components/input'
import Label from 'uni-view/components/label'
import MovableArea from 'uni-view/components/movable-area'
import MovableView from 'uni-view/components/movable-view'
import Navigator from 'uni-view/components/navigator'
import PickerView from 'uni-view/components/picker-view'
import PickerViewColumn from 'uni-view/components/picker-view-column'
import Radio from 'uni-view/components/radio'
import RadioGroup from 'uni-view/components/radio-group'
import ResizeSensor from 'uni-view/components/resize-sensor'
import RichText from 'uni-view/components/rich-text'
import ScrollView from 'uni-view/components/scroll-view'
import Swiper from 'uni-view/components/swiper'
import SwiperItem from 'uni-view/components/swiper-item'
import Text from 'uni-view/components/text'
import Textarea from 'uni-view/components/textarea'
import View from 'uni-platform/view/components/view'
import WebView from 'uni-platform/view/components/web-view'
Button.name = 'VUniButton'
     Button.mixins = Button.mixins ? [].concat(baseMixin, Button.mixins) : [baseMixin]
     Button.mixins.push(animation)
     Vue.component(Button.name,Button)
Canvas.name = 'VUniCanvas'
     Canvas.mixins = Canvas.mixins ? [].concat(baseMixin, Canvas.mixins) : [baseMixin]
     Canvas.mixins.push(animation)
     Vue.component(Canvas.name,Canvas)
CoverView.name = 'VUniCoverView'
     CoverView.mixins = CoverView.mixins ? [].concat(baseMixin, CoverView.mixins) : [baseMixin]
     CoverView.mixins.push(animation)
     Vue.component(CoverView.name,CoverView)
Image.name = 'VUniImage'
     Image.mixins = Image.mixins ? [].concat(baseMixin, Image.mixins) : [baseMixin]
     Image.mixins.push(animation)
     Vue.component(Image.name,Image)
Input.name = 'VUniInput'
     Input.mixins = Input.mixins ? [].concat(baseMixin, Input.mixins) : [baseMixin]
     Input.mixins.push(animation)
     Vue.component(Input.name,Input)
Label.name = 'VUniLabel'
     Label.mixins = Label.mixins ? [].concat(baseMixin, Label.mixins) : [baseMixin]
     Label.mixins.push(animation)
     Vue.component(Label.name,Label)
MovableArea.name = 'VUniMovableArea'
     MovableArea.mixins = MovableArea.mixins ? [].concat(baseMixin, MovableArea.mixins) : [baseMixin]
     MovableArea.mixins.push(animation)
     Vue.component(MovableArea.name,MovableArea)
MovableView.name = 'VUniMovableView'
     MovableView.mixins = MovableView.mixins ? [].concat(baseMixin, MovableView.mixins) : [baseMixin]
     MovableView.mixins.push(animation)
     Vue.component(MovableView.name,MovableView)
Navigator.name = 'VUniNavigator'
     Navigator.mixins = Navigator.mixins ? [].concat(baseMixin, Navigator.mixins) : [baseMixin]
     Navigator.mixins.push(animation)
     Vue.component(Navigator.name,Navigator)
PickerView.name = 'VUniPickerView'
     PickerView.mixins = PickerView.mixins ? [].concat(baseMixin, PickerView.mixins) : [baseMixin]
     PickerView.mixins.push(animation)
     Vue.component(PickerView.name,PickerView)
PickerViewColumn.name = 'VUniPickerViewColumn'
     PickerViewColumn.mixins = PickerViewColumn.mixins ? [].concat(baseMixin, PickerViewColumn.mixins) : [baseMixin]
     PickerViewColumn.mixins.push(animation)
     Vue.component(PickerViewColumn.name,PickerViewColumn)
Radio.name = 'VUniRadio'
     Radio.mixins = Radio.mixins ? [].concat(baseMixin, Radio.mixins) : [baseMixin]
     Radio.mixins.push(animation)
     Vue.component(Radio.name,Radio)
RadioGroup.name = 'VUniRadioGroup'
     RadioGroup.mixins = RadioGroup.mixins ? [].concat(baseMixin, RadioGroup.mixins) : [baseMixin]
     RadioGroup.mixins.push(animation)
     Vue.component(RadioGroup.name,RadioGroup)
ResizeSensor.name = 'VUniResizeSensor'
     ResizeSensor.mixins = ResizeSensor.mixins ? [].concat(baseMixin, ResizeSensor.mixins) : [baseMixin]
     ResizeSensor.mixins.push(animation)
     Vue.component(ResizeSensor.name,ResizeSensor)
RichText.name = 'VUniRichText'
     RichText.mixins = RichText.mixins ? [].concat(baseMixin, RichText.mixins) : [baseMixin]
     RichText.mixins.push(animation)
     Vue.component(RichText.name,RichText)
ScrollView.name = 'VUniScrollView'
     ScrollView.mixins = ScrollView.mixins ? [].concat(baseMixin, ScrollView.mixins) : [baseMixin]
     ScrollView.mixins.push(animation)
     Vue.component(ScrollView.name,ScrollView)
Swiper.name = 'VUniSwiper'
     Swiper.mixins = Swiper.mixins ? [].concat(baseMixin, Swiper.mixins) : [baseMixin]
     Swiper.mixins.push(animation)
     Vue.component(Swiper.name,Swiper)
SwiperItem.name = 'VUniSwiperItem'
     SwiperItem.mixins = SwiperItem.mixins ? [].concat(baseMixin, SwiperItem.mixins) : [baseMixin]
     SwiperItem.mixins.push(animation)
     Vue.component(SwiperItem.name,SwiperItem)
Text.name = 'VUniText'
     Text.mixins = Text.mixins ? [].concat(baseMixin, Text.mixins) : [baseMixin]
     Text.mixins.push(animation)
     Vue.component(Text.name,Text)
Textarea.name = 'VUniTextarea'
     Textarea.mixins = Textarea.mixins ? [].concat(baseMixin, Textarea.mixins) : [baseMixin]
     Textarea.mixins.push(animation)
     Vue.component(Textarea.name,Textarea)
View.name = 'VUniView'
     View.mixins = View.mixins ? [].concat(baseMixin, View.mixins) : [baseMixin]
     View.mixins.push(animation)
     Vue.component(View.name,View)
WebView.name = 'VUniWebView'
     WebView.mixins = WebView.mixins ? [].concat(baseMixin, WebView.mixins) : [baseMixin]
     WebView.mixins.push(animation)
     Vue.component(WebView.name,WebView)
